var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState, } from "react";
// material
import { Box, InputAdornment, Popover, Stack } from "@mui/material";
// icons
import FilterListIcon from "@mui/icons-material/FilterList";
// form
import { useForm, useFormContext, useWatch, } from "react-hook-form";
//constants | types
import { COLORS } from "../../../constants";
//components
import { ChipV2 as Chip } from "../../Atoms";
import { HookTextField } from "../../Molecules";
import { ClearApplyButtons } from "../../Common";
// helpers
import { getDotNotationValue, minMaxMessaging } from "../../../helpers";
var MinMaxForm = function (_a, ref) {
    var _b;
    var _c, _d;
    var onSubmit = _a.onSubmit, onClose = _a.onClose, onClear = _a.onClear, _e = _a.minName, minName = _e === void 0 ? "minValue" : _e, _f = _a.minLabel, minLabel = _f === void 0 ? "Min" : _f, _g = _a.minPlaceholder, minPlaceholder = _g === void 0 ? "No min" : _g, minInputProps = _a.minInputProps, _h = _a.maxName, maxName = _h === void 0 ? "maxValue" : _h, _j = _a.maxLabel, maxLabel = _j === void 0 ? "Max" : _j, _k = _a.maxPlaceholder, maxPlaceholder = _k === void 0 ? "No max" : _k, maxInputProps = _a.maxInputProps, _l = _a.clearCtaText, clearCtaText = _l === void 0 ? "Clear" : _l, _m = _a.submitCtaText, submitCtaText = _m === void 0 ? "Apply" : _m, _o = _a.asChip, asChip = _o === void 0 ? true : _o, withinForm = _a.withinForm, sx = _a.sx, chipProps = _a.chipProps, values = _a.values, _p = _a.clearable, clearable = _p === void 0 ? true : _p, chipLabel = _a.chipLabel, _q = _a.chipStartWord, chipStartWord = _q === void 0 ? "Owns" : _q, _r = _a.chipEndWord, chipEndWord = _r === void 0 ? "share" : _r, isPercent = _a.isPercent;
    var chipRef = useRef(null);
    // allow parent ref to run triggerPopover
    useImperativeHandle(ref, function () { return ({ triggerPopover: triggerPopover }); });
    // for popover
    var _s = __read(useState(null), 2), anchorEl = _s[0], setAnchorEl = _s[1];
    // if this is used within a form
    var outerForm = useFormContext();
    // values retrieved from provided field names
    var fullDotMinPath = "".concat(withinForm === null || withinForm === void 0 ? void 0 : withinForm.fieldName, ".").concat(withinForm === null || withinForm === void 0 ? void 0 : withinForm.minName);
    var fullDotMaxPath = "".concat(withinForm === null || withinForm === void 0 ? void 0 : withinForm.fieldName, ".").concat(withinForm === null || withinForm === void 0 ? void 0 : withinForm.maxName);
    var formMin = withinForm ? useWatch({ name: fullDotMinPath }) : undefined;
    var formMax = withinForm ? useWatch({ name: fullDotMaxPath }) : undefined;
    // values currently being used outside this popover
    var previousValues = values || (_b = {}, _b[maxName] = formMax, _b[minName] = formMin, _b);
    // if a value is currently set so we can show clear
    var hasValue = !isNaN(formMin) || !isNaN(formMax) || values;
    // get current values from outside this component
    var getDefaultValues = function () {
        var _a;
        if (!!withinForm && !!outerForm) {
            var data = outerForm.getValues();
            return _a = {},
                _a[maxName] = getDotNotationValue(data, fullDotMaxPath),
                _a[minName] = getDotNotationValue(data, fullDotMinPath),
                _a;
        }
        else {
            return values || {};
        }
    };
    var methods = useForm({
        criteriaMode: "all",
        mode: "all",
    });
    var watch = methods.watch, trigger = methods.trigger, getValues = methods.getValues, control = methods.control, reset = methods.reset, _t = methods.formState, isValid = _t.isValid, errors = _t.errors, isDirty = _t.isDirty;
    // reset fields whenever popover is opened or outside values change
    useEffect(function () {
        var defaultVals = getDefaultValues();
        reset(defaultVals);
    }, [anchorEl, values]);
    // blur chip on close
    useEffect(function () {
        var _a;
        if (!anchorEl) {
            (_a = chipRef === null || chipRef === void 0 ? void 0 : chipRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        }
    }, [anchorEl, hasValue]);
    var _u = watch(), _v = maxName, max = _u[_v], _w = minName, min = _u[_w];
    /**
     * When valid is flipped, re-validate other input if it is displaying an error
     */
    useEffect(function () {
        if (isValid) {
            if (errors[maxName]) {
                trigger(maxName);
            }
            if (errors[minName]) {
                trigger(minName);
            }
        }
    }, [isValid]);
    /**
     * open popver when chips clicked
     */
    var handleChipClick = function (e) {
        setAnchorEl(e.currentTarget);
    };
    /**
     * Similar to handleChipClick, but triggered from the parent component to automate the selection
     */
    var triggerPopover = function () {
        setAnchorEl(chipRef.current);
    };
    /**
     * clear whenever delet icon is clicked
     */
    var handleChipDeleteClick = function () {
        clear();
    };
    /**
     * reset form
     * call onClear callback
     * clear outside form values if exist
     * close popover
     */
    var clear = function () {
        reset();
        if (onClear) {
            onClear();
        }
        if (withinForm) {
            outerForm.setValue(withinForm.fieldName, undefined, {
                shouldDirty: true,
            });
        }
        closePopover();
    };
    /**
     * close popover and trigger a close callback if one exists
     */
    var closePopover = function () {
        setAnchorEl(null);
        if (onClose) {
            onClose();
        }
    };
    /**
     * Apply form data
     */
    var handleSubmit = function () {
        var data = getValues();
        if (withinForm && outerForm) {
            outerForm.setValue(fullDotMinPath, data[minName] === "" ? undefined : data[minName], {
                shouldDirty: true,
            });
            outerForm.setValue(fullDotMaxPath, data[maxName] === "" ? undefined : data[maxName], {
                shouldDirty: true,
            });
        }
        else if (onSubmit) {
            onSubmit(data);
        }
        closePopover();
    };
    // display label for chip
    var messaging = minMaxMessaging((_c = previousValues[minName]) === null || _c === void 0 ? void 0 : _c.toString(), (_d = previousValues[maxName]) === null || _d === void 0 ? void 0 : _d.toString(), chipStartWord, chipEndWord, isPercent);
    var form = (_jsxs(Stack, __assign({ sx: sx }, { children: [_jsxs(Stack, __assign({ direction: "row" }, { children: [_jsx(HookTextField, __assign({ name: minName, id: minName, type: "number", wrapperSx: {
                            flex: 1,
                            ".MuiFormControl-root": {
                                width: "100%",
                            },
                        }, placeholder: minPlaceholder, outerLabel: minLabel, endAdornment: isPercent ? "%" : undefined, control: control, inputProps: {
                            min: 0,
                            max: isPercent ? 100 : undefined,
                        }, rules: {
                            min: {
                                value: 0,
                                message: "Negative values not allowed",
                            },
                            validate: {
                                lowerThanMax: function (val) {
                                    // ensure users value is less than max or no max exists
                                    if (!!val && Number(val) > Number(max) && !!max) {
                                        return "Must be less than max";
                                    }
                                    else if (isPercent && Number(val) > 100) {
                                        return "Must not exceed 100%";
                                    }
                                    else {
                                        return true;
                                    }
                                },
                            },
                        } }, minInputProps)), _jsx(Box, { mx: 2, mt: 12.5, bgcolor: COLORS.P_OUTLINE, height: "1px", width: 8 }), _jsx(HookTextField, __assign({ name: maxName, id: maxName, type: "number", wrapperSx: {
                            flex: 1,
                            ".MuiFormControl-root": {
                                width: "100%",
                            },
                        }, placeholder: maxPlaceholder, outerLabel: maxLabel, endAdornment: isPercent ? (_jsx(InputAdornment, __assign({ position: "end" }, { children: "%" }))) : undefined, control: control, inputProps: {
                            min: 0,
                            max: isPercent ? 100 : undefined,
                        }, InputLabelProps: {
                            sx: {
                                ".MuiTypography-root": { width: "100%", textAlign: "right" },
                            },
                        }, rules: {
                            validate: {
                                greaterThanMin: function (val) {
                                    // ensure users value is more than min or no min exists
                                    if (!!min && Number(min) > Number(val) && !!val) {
                                        return "Must be greater than min";
                                    }
                                    else if (isPercent && Number(val) > 100) {
                                        return "Must not exceed 100%";
                                    }
                                    else {
                                        return true;
                                    }
                                },
                            },
                            min: {
                                value: 0,
                                message: "Negative values not allowed",
                            },
                        } }, maxInputProps))] })), _jsx(ClearApplyButtons, { handleSubmit: handleSubmit, onClear: clear, clearCtaText: clearCtaText, submitCtaText: submitCtaText, isValid: isValid, isDirty: isDirty })] })));
    if (asChip) {
        return (_jsxs(Box, __assign({ sx: sx }, { children: [_jsx(Chip, __assign({}, chipProps, { variant: "secondary", "data-testid": "minmax-chip", selected: !!hasValue || !!anchorEl, ref: chipRef, icon: _jsx(FilterListIcon, {}), onClick: handleChipClick, onDelete: hasValue && clearable ? handleChipDeleteClick : undefined, label: messaging || chipLabel })), _jsx(Popover, __assign({ id: "minmax-form-popover", "data-testid": "minmax-form-popover", open: !!anchorEl, PaperProps: {
                        sx: {
                            borderRadius: 2,
                            width: "100%",
                            maxWidth: 380,
                        },
                    }, anchorEl: anchorEl, onClose: closePopover, anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                    }, transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                    } }, { children: _jsx(Box, __assign({ p: 4 }, { children: form })) }))] })));
    }
    else {
        return form;
    }
};
export default forwardRef(MinMaxForm);
